/* eslint-disable react/function-component-definition */
/* eslint-disable import/no-unresolved */
import { FormikProps } from "formik";
import { FC, memo } from "react";
import CustomReviewField from "src/shared/CustomReviewField";
import MedicalSelectBox from "src/shared/MedicalLifeStyle/MedicalSelextBox";
import MedicalTextBox from "src/shared/MedicalLifeStyle/MedicalTextBox";

interface Props {
  formik: FormikProps<any>;
  editable?: boolean;
}

const BMIInformation: FC<Props> = ({ formik, editable }) => (
  <>
    {editable && (
      <>
        <div className="flex xl:flex-row lg:flex-row md:flex-row sm:flex-row flex-col mt-6">
          <div className="flex flex-row xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-4 lg:w-60 md:w-60 w-auto h-16">
            <MedicalTextBox
              globalClassName="rounded-l-lg"
              requiredStar
              label="Weight"
              className="!w-full"
              onChange={formik?.handleChange}
              handleBlur={formik?.handleBlur}
              value={formik?.values?.weight || null}
              name="weight"
              error={formik?.errors?.weight as string}
              touched={formik?.touched?.weight as boolean}
              disabledField={!editable}
            />
            <div>
              <MedicalTextBox
                globalClassName="rounded-r-lg"
                className="!w-20"
                label="Measurement"
                onChange={formik?.handleChange}
                name="Kgs"
                disabledField
                value="Kg"
                handleBlur={formik?.handleBlur}
              />
            </div>
          </div>

          {formik?.values?.measurement === "cm" && (
            <div className="flex flex-row xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 h-14 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mr-4">
              <MedicalTextBox
                globalClassName="rounded-l-lg"
                requiredStar
                label="Height"
                className="xl:w-38 lg:w-38 md:w-38 w-full xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-5"
                onChange={formik?.handleChange}
                handleBlur={formik?.handleBlur}
                value={formik?.values?.height?.centimeter?.cm || null}
                name="height.centimeter.cm"
                error={(formik?.errors?.height as any)?.centimeter?.cm}
                touched={(formik?.touched?.height as any)?.centimeter?.cm}
                disabledField={!editable}
              />
              <MedicalSelectBox
                className="!w-20 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-5"
                label="Measurement"
                options={["cm", "Inch/Ft"]}
                onChange={formik?.handleChange}
                setFieldTouched={formik?.setFieldTouched}
                name="measurement"
                disabledField={!editable}
                value={formik?.values?.measurement || null}
              />
            </div>
          )}
          {formik?.values?.measurement !== "cm" && (
            <div className="flex flex-row">
              <div className="xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-4 h-14">
                <MedicalTextBox
                  globalClassName="rounded-l-lg"
                  requiredStar
                  label="Feet"
                  className="xl:w-19.5 lg:w-19.5 md:w-19.5 w-full xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-5"
                  onChange={formik?.handleChange}
                  handleBlur={formik?.handleBlur}
                  value={formik?.values?.height?.inchFeet?.feet || null}
                  name="height.inchFeet.feet"
                  error={(formik?.errors?.height as any)?.inchFeet?.feet}
                  touched={(formik?.touched?.height as any)?.inchFeet?.feet}
                  disabledField={!editable}
                />
                &ensp;
              </div>
              <div className=" h-14">
                <MedicalTextBox
                  globalClassName=""
                  requiredStar
                  label="Inches"
                  className="xl:w-19.5 lg:w-19.5 md:w-19.5 w-full xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-5"
                  onChange={formik?.handleChange}
                  handleBlur={formik?.handleBlur}
                  value={formik?.values?.height?.inchFeet?.inches || null}
                  name="height.inchFeet.inches"
                  error={(formik?.errors?.height as any)?.inchFeet?.inches}
                  touched={(formik?.touched?.height as any)?.inchFeet?.inches}
                  disabledField={!editable}
                />
              </div>
              <div className=" h-14">
                <MedicalSelectBox
                  className="w-20 xl:mt-0 lg:mt-0 md:mt-0 sm:mt-0 mt-5 mr-4 "
                  label="Measurement"
                  options={["cm", "Inch/Ft"]}
                  onChange={formik?.handleChange}
                  setFieldTouched={formik?.setFieldTouched}
                  name="measurement"
                  disabledField={!editable}
                  value={formik?.values?.measurement || ""}
                />
              </div>
            </div>
          )}
        </div>
        <hr className="border-dashed border-t-2 mt-10 mb-6.5 border-daintree opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
      </>
    )}
    {!editable && (
      <>
        <div>
          <div className="flex items-center mt-6">
            <h1 className="xl:ml-18 lg:ml-18 md:ml-18 sm:ml-18 ml-5 w-24">Weight*</h1>
            <div className="ml-20 xl:ml-42.25 lg:ml-33 md:ml-33 sm:ml-24 w-24">
              <h1>Height*</h1>
            </div>
          </div>

          <div className="flex items-center mt-3">
            <h1 className="xl:ml-18 lg:ml-18 md:ml-18 sm:ml-18 ml-5 w-24">
              {formik?.values?.weight ? (
                <CustomReviewField>{formik?.values?.weight} Kgs </CustomReviewField>
              ) : (
                ""
              )}
            </h1>
            <div className="ml-20 xl:ml-42.25 lg:ml-33 md:ml-33 sm:ml-24 w-24 whitespace-nowrap">
              <h1>
                {formik?.values?.height?.centimeter?.cm !== "" ? (
                  <CustomReviewField>{formik.values?.height?.centimeter?.cm} Cm</CustomReviewField>
                ) : (
                  <CustomReviewField>
                    {formik?.values?.height?.inchFeet?.feet} Feet &ensp;
                    {formik?.values?.height?.inchFeet?.inches} Inches
                  </CustomReviewField>
                )}
              </h1>
            </div>
          </div>
        </div>
        <hr className="border-dashed border-t-2 mt-10 mb-6.5 border-daintree  opacity-10 xl:ml-10 lg:ml-10 md:ml-10 sm:ml-10 ml-0 xl:mr-10 lg:mr-10 md:mr-10 sm:mr-10 mr-0" />
      </>
    )}
  </>
);

BMIInformation.defaultProps = {
  editable: false
};

export default memo(BMIInformation);
